import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Area, Employee } from '../state/types'

export const useEmployeeLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllEmployees = (active = false) => getList(TableName.EMPLOYEES, active) as Employee[]

        const findEmployee = (id?: string) => find(TableName.EMPLOYEES, id) as O<Employee>

        const findAreasEmployees = (areas: Area[]) => findAllEmployees().filter(employee => areas.includes(employee.area))

        const loadAllEmployees = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.EMPLOYEES, options)
            return response.dataTypes as Employee[]
        }

        const loadEmployee = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.EMPLOYEES, id, dbRequest) as Promise<O<Employee>>
        }
        
        return {
            findAllEmployees,
            findEmployee,
            findAreasEmployees,
            loadAllEmployees,
            loadEmployee
        }
    }
}
